import { render } from "./BaseTextareaInput.vue?vue&type=template&id=2e670e7e"
import script from "./BaseTextareaInput.vue?vue&type=script&lang=js"
export * from "./BaseTextareaInput.vue?vue&type=script&lang=js"

import exportComponent from "/Users/filip/coding/shean/reklamace/reklamace-fe-slovakova/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__